module.exports = __webpack_public_path__ + "static/media/model_en.b2dfafa9.png";